import React from 'react';
import { useHistory } from 'react-router-dom';

import { useMutation, useQueryClient } from '@sopranodesign/pulse-hooks';
import { PageWrapper, useNotification } from '@sopranodesign/pulse-components';

import { McpProviderDetails } from '../Components/index';
import { createProvider } from '../api/index';

const CreateMcpProvider = () => {
  const history = useHistory();
  const { showSuccess } = useNotification();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createProvider,
    onSuccess: () => {
      showSuccess('Provider created');
      queryClient.invalidateQueries('mcp-skill-providers');
      history.push('/mcp/providers');
    }
  });

  return (
    <PageWrapper
      header="New MCP Provider"
      subheader="Connect to an MCP-compatible server">
      <McpProviderDetails
        handleSubmit={form => mutation.mutate(form)}
        loading={mutation.isPending}
      />
    </PageWrapper>
  );
};

export default CreateMcpProvider;
